import {GAME_TYPES} from "../../../constants/game";
import {FLAG_PREFIX} from "../../../constants/tokens";
import {
  selectGameType,
  selectHexes,
  selectPlayers,
  selectRound,
  selectStartingQuarters,
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {getActingPlayerFromState} from "../../players/getActingPlayer";

const checkIfHasFlags = (hexes) => Object.values(hexes || {})
  .some((token) => String(token).startsWith(FLAG_PREFIX));

/**
 * Посадку чьего квартала этот клиент уже видел: своего игрока, а в локальной партии
 * всех живых игроков — они выбирали за этим же экраном. Текущий игрок для этого не
 * годится: последним расстановку может заканчивать бот
 */
const checkIfQuarterAlreadySeen = (prevState, player) => {
  if (selectGameType(prevState) === GAME_TYPES.LOCAL) {
    return !player.isBot;
  }
  return getActingPlayerFromState(prevState)?.id === player.id;
};

/**
 * Какие стартовые кварталы стали видны этому клиенту с концом расстановки: флаги с поля
 * сняты, и на их месте появились центральные кварталы (см. редьюсер, COMPLETE_PHASE).
 *
 * Клиент мог вернуться к партии намного позже: тогда смотреть уже не на что, поэтому
 * только первый раунд.
 *
 * @param {Object} prevState — состояние прошлой перерисовки поля
 * @param {Object} state
 * @returns {Array<{hexKey: string, tokenType: string}>}
 */
export const resolveRevealedStartingQuarters = (prevState, state) => {
  const hexes = selectHexes(state);
  if (selectHexes(prevState) === hexes
    || !checkIfHasFlags(selectHexes(prevState))
    || checkIfHasFlags(hexes)
    || selectRound(state) > 1) {
    return [];
  }

  const startingQuarters = selectStartingQuarters(state) || {};
  return selectPlayers(state)
    .filter((player) => !checkIfQuarterAlreadySeen(prevState, player))
    .map((player) => ({hexKey: startingQuarters[player.id], tokenType: `central_quarter_${player.color}`}))
    .filter(({hexKey, tokenType}) => hexKey && hexes[hexKey] === tokenType);
};
